/**
 * Common functions for where we use Parsley - includes various validators plus a helpful scroll function
 */

export function enableParsleyPostcodeValidator() {
	console.log("ParsleyUtils.enableParsleyPostcodeValidator()");

	window.Parsley.addValidator('postcode', {
		validateString: function(value, countryTarget) {
			// Allow anything for non-GB/UK
			var country = document.querySelector(countryTarget);
			if(country != null && country.value != "GB") {
				return true;
			}
			// Pattern lifted from https://ideal-postcodes.co.uk/guides/postcode-validation
			var postcodePattern = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/gi
			// Clean up our input
			var ucPostcode = value.trim().replace(" ", "");
			// Compare against postcode pattern
			var result = ucPostcode.match(postcodePattern)
			// If there is a match, return true, otherwise false
			return result !== null
		}
	});
}

export function enableParsleyBlocklistValidator() {
	console.log("ParsleyUtils.enableParsleyBlocklistValidator()");

	window.Parsley.addValidator('blocklist', {
		validateString: function(value, blocklistStr) {
			if(value == null || value.trim() == "" || blocklistStr == null || blocklistStr.trim() == "") return true
			var blocklist = blocklistStr.toLowerCase().trim().split('|');
			return !blocklist.includes(value.toLowerCase().trim());
		}
	});
}

export function enableParsleyNotEmailValidator() {
	console.log("ParsleyUtils.enableParsleyNotEmailValidator()");

	window.Parsley.addValidator('notemail', {
		validateString: function(value) {
			if(value == null || !value.includes('@')) return true;
			value = value.toLowerCase();
			return !(value.includes('.co') || value.includes('.org') || value.includes('.net') || value.includes('.uk'));
		}
	});
}

export function enableParsleyNotHtmlValidator() {
	console.log("ParsleyUtils.enableParsleyNotHtmlValidator()");

	window.Parsley.addValidator('nohtml', {
		validateString: function(value) {
			return !/<.*?>|&lt;.*?&gt;|`.*?`|<\/?\w+>|script|<|>/gi.test(value);
    	}
  });
}

export function scrollToParsleyError(e, parentSelector, sectionSelector) {
	const firstError = $($(parentSelector || "main").find(".parsley-errors-list li")[0]);
	const closestContainer = sectionSelector ? firstError.closest(sectionSelector) : firstError;
	$("html, body").animate({scrollTop: (closestContainer.offset() || firstError.offset() || $("main").offset()).top - 50}, "fast");
}